import { ContentCollectionHorizontal } from "contentCollection";
import { Id, config, content } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import React from "react";
function isCompatible(program) {
    return program.recentVideos !== null && program.recentVideos.length > 0;
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    return Option.some({
        key: "programRecentVideos",
        View: function () { return (React.createElement(ContentCollectionHorizontal, { componentId: Id.component.contentCollection.recentVideos, listName: config.tracking.listNames.recentVideos, title: content.title.recentVideos, items: data.recentVideos, trackingEnabled: !data.fetchingData })); },
    });
};
